export default __webpack_public_path__ + "static/media/gcp.619b6909.png";